module.exports = __webpack_public_path__ + "static/media/FO-V-AC-005.1c8a7d80.pdf";